<template>
    <Transition 
        :name="transitionName" 
        @before-enter="handleBeforeEnter"
        @enter="handleEntering"
        @after-enter="handleAfterEnter"
        @before-leave="handleBeforeLeave" 
        @leave="handleLeaving" 
        @after-leave="handelAfterLeave"
        :style="dynamicStyle"
    >
        <slot></slot>
    </Transition>
</template>
<script>
const transitionMap = {
    height: 'drawer', // 抽屉动效
    opacity: 'shadeInOut', // 淡入淡出动效
}
// 封装的定制transition动效组件
export default{
    name: "CustomTransition",
    props:{
        property:{
            type: String,
            default: () => ""
        },
        duration:{
            type: String,
            default: () => "0.3s"
        },
        beginStyle:{
            type: Object,
            default: () => {
                return {}
            }
        },
        endStyle:{
            type: Object,
            default: () => {
                return {}
            }
        },
        mode: {
            type: String,
            default: () => "ease-in-out"
        },
        // 从什么地方开始动效
        transformOrigin: {
            type: String,
            default: "bottom",
        }
    },
    computed:{
        transitionName(){
            return transitionMap[this.property]
        },
        constStyle(){
            return{
                transition: `${this.property} ${this.duration} ${this.mode}`,
                'transform-origin': this.transformOrigin
            }
        }
    },
    data() {
        return {
            dynamicStyle: {}, // 动态style
        }
    },
    methods: {
        handleBeforeEnter(){
        },
        handleEntering(){
            this.endStyle && ( this.dynamicStyle = { ...this.constStyle, ...this.endStyle } )
        },
        handleAfterEnter(){
        },
        handleBeforeLeave(){
        },
        handleLeaving(){
            console.log("leaving")
            this.beginStyle && (this.dynamicStyle = {...this.constStyle, ...this.beginStyle})
        },
        handelAfterLeave(){
        },
    },
}
</script>
<style lang="less" scoped>
.drawer-enter-active, .drawer-leave-active{
    transition: all 0.3s ease-in-out;
    opacity: 1;
    visibility: visible;
}
.drawer-enter,.drawer-enter-from,.drawer-leave-to{
    height: 0px !important;
    opacity: 0;
    visibility: hidden !important;
}
</style>